<div class="d-flex justify-content-center w-100">
    <div class="loader" [style.width.px]="width()"></div>
</div>
